import { getUserTimeZone } from 'owa-session-store';
import { OwaDate } from 'owa-datetime';

export default (value: OwaDate | null | undefined, timeZoneId?: string) =>
    value ? value.tz : timeZoneId || getUserTimeZone();
